import React, { useState, useContext, useEffect, useRef } from "react";
import styled, { createGlobalStyle } from "styled-components";
import { motion, AnimatePresence } from "framer-motion";
import { DirectionContext } from "../App";
import Select from "react-select";
import Cookies from "js-cookie";
import API_ENDPOINTS from "../config/api";

// 인증수단 목록 데이터
const authMethodOptions = [
  {
    value: "kakao",
    label: "카카오",
    icon: "/png/kakaoIcon.png",
    isDisabled: false,
  },
  {
    value: "naver",
    label: "네이버",
    icon: "/png/naverIcon.png",
    isDisabled: true,
    isPreparing: true,
  },
  {
    value: "toss",
    label: "토스",
    icon: "/png/tossIcon.png",
    isDisabled: true,
    isPreparing: true,
  },
  {
    value: "none",
    label: "인증이 불가해요",
    icon: "/png/noIcon.png",
    isDisabled: false,
  },
];

// 이용약관 JSX 컴포넌트
const TermsContent = () => (
  <TermsContentContainer>
    <TermsIntro>
      이용약관
      <br />
      쿠팡 개인정보 유출 집단소송을 이용해주시는 모든 분들께 감사드립니다. 아래
      약관은 저희의 서비스를 이용하는 여러분 모두에게 적용되니 시간을 내어
      확인해주세요.
    </TermsIntro>

    <TermsChapter>
      <TermsChapterTitle>제1장 총칙</TermsChapterTitle>

      <TermsSection>
        <TermsSectionTitle>제1조 (목적)</TermsSectionTitle>
        <TermsText>
          이 약관은 법무법인 더 에이치 황해(이하 '더 에이치 황해')가 쿠팡
          개인정보 유출 집단소송 사이트와 앱을 통해 제공하는 모든 서비스(이하
          '서비스')의 이용조건 및 절차, 이용자와 사이트의 권리, 의무, 책임사항과
          기타 필요한 사항을 정합니다.
        </TermsText>
      </TermsSection>

      <TermsSection>
        <TermsSectionTitle>제2조 (약관의 효력과 변경)</TermsSectionTitle>
        <TermsText>
          ① 이 약관은 더 에이치 황해가 운영하는 쿠팡 개인정보 유출 집단소송
          사이트 및 앱에 게시함으로써 효력이 발생합니다.
        </TermsText>
        <TermsText>
          ② 더 에이치 황해는 여러분이 이 약관의 내용에 동의하는 것을 조건으로
          서비스를 제공합니다. 서비스 제공 및 이용과 관련하여 이 약관이
          우선적으로 적용됩니다.
        </TermsText>
        <TermsText>
          ③ 더 에이치 황해는 약관을 변경할 수 있으며, 변경된 약관은 사이트 및 앱
          내에 게시함으로써 효력이 발생합니다.
        </TermsText>
        <TermsText>
          ④ 더 에이치 황해가 약관을 변경할 때에는 시행 일자를 명시하여 그
          시행일자 30일 전부터 사이트 및 앱 내에 게시합니다. 변경된 약관에
          동의하지 않는 회원의 경우 회원탈퇴를 할 수 있고, 회원탈퇴를 하지 않은
          경우에는 변경된 약관에 동의하는 것으로 간주합니다.
        </TermsText>
      </TermsSection>
    </TermsChapter>

    <TermsChapter>
      <TermsChapterTitle>제2장 서비스 제공 및 이용</TermsChapterTitle>

      <TermsSection>
        <TermsSectionTitle>
          제3조 (이용계약의 성립 및 이용계약상 지위의 양도)
        </TermsSectionTitle>
        <TermsText>
          ① 여러분이 더 에이치 황해가 제공하는 가입 절차에 따라 사이트 또는 앱에
          가입하시면 여러분과 더 에이치 황해 사이에 이용계약이 성립합니다. 이에
          따라 이용계약이 성립한 서비스 이용자를 "회원"이라 합니다.
        </TermsText>
        <TermsText>
          ② 더 에이치 황해는 다음 각 호에 해당하는 이용계약에 대하여 가입을
          취소할 수 있습니다.
        </TermsText>
        <TermsList>
          <li>다른 사람의 명의를 사용하여 가입하였을 때</li>
          <li>가입 시 요구되는 정보의 내용을 허위로 기재하였을 때</li>
          <li>사회의 안녕 질서 혹은 미풍양속을 저해할 의도로 가입하였을 때</li>
          <li>
            다른 사람의 서비스 이용을 방해하거나 그 정보를 도용하는 등의 행위를
            하였을 때
          </li>
          <li>
            서비스를 이용하면서 법령 또는 이 약관이 금지하는 행위를 하였을 때
          </li>
          <li>기타 더 에이치 황해가 정한 가입요건이 충족되지 않았을 때</li>
        </TermsList>
        <TermsText>
          ③ 더 에이치 황해는 다음 각 호에 해당하는 경우에는 그 사유가 해소될
          때까지 가입을 유보할 수 있습니다.
        </TermsText>
        <TermsList>
          <li>기술상의 장애사유로 인한 서비스 중단의 경우</li>
          <li>
            전기통신사업법에 의한 기간통신사업자가 전기통신 서비스를 중지하는
            경우
          </li>
          <li>
            전시, 사변, 국가 비상사태 또는 이에 준하는 천재지변이 발생하거나
            발생할 우려가 있는 경우
          </li>
          <li>
            긴급한 시스템 점검, 증설 및 교체설비의 보수 등을 위하여 부득이한
            경우
          </li>
          <li>
            서비스 설비 장애, 서비스 이용의 폭주 등 서비스를 제공할 수 없는
            사유가 발생한 경우
          </li>
          <li>
            기타 더 에이치 황해가 재정적, 기술적으로 필요하다고 판단하는 경우
          </li>
        </TermsList>
        <TermsText>
          ④ 회원은 서비스 이용계약상의 지위, 서비스 이용 권한을 다른 사람에게
          대여, 양도, 증여하거나 담보로 제공할 수 없습니다.
        </TermsText>
      </TermsSection>

      <TermsSection>
        <TermsSectionTitle>제4조 (서비스 제공 및 중단 등)</TermsSectionTitle>
        <TermsText>
          ① 이용계약이 성립되면 회원은 더 에이치 황해가 제공하는 서비스를
          자유롭게 이용할 수 있습니다. 다만, 일부 서비스의 경우 본인확인,
          개인정보수집 및 제3자 제공 동의 등 별도의 절차를 완료하여야 이용이
          가능할 수 있습니다.
        </TermsText>
        <TermsText>
          ② 더 에이치 황해는 회원에게 서비스를 제공하기 위해 최선의 노력을
          다합니다. 다만, 정상적으로 서비스를 제공하기 어려운 사정이 발생하여
          일시적이거나 영구적으로 서비스를 전부 중단하여야 할 경우에는
          중단일로부터 1주일 전에 사이트 내에 그 사유를 게시하고 서비스를 중단할
          수 있습니다. 부득이한 사정이 있을 경우 위 사전 게시기간은 감축되거나
          생략될 수 있습니다.
        </TermsText>
        <TermsText>
          ③ 제2항에서 정한 서비스 중단에 의하여 더 에이치 황해에 보관 또는
          전송된 정보의 내용이 보관되지 못하였거나 삭제된 경우, 전송되지 못한
          경우 및 기타 통신 데이터의 손실이 발생하는 경우 더 에이치 황해는 회원
          또는 제3자에게 책임을 지지 않습니다.
        </TermsText>
        <TermsText>
          ④ 더 에이치 황해는 더 나은 서비스 제공을 위하여 회원 정보에 등록되어
          있는 연락처로 서비스에 관한 안내 사항을 발송할 수 있습니다. 단, 광고성
          정보는 사전에 수신 동의한 회원에게만 발송됩니다.
        </TermsText>
        <TermsText>
          ⑤ 더 에이치 황해는 서비스의 본 약관의 내용에 위배되는 행동을 한 회원에
          대하여 임의로 서비스 사용을 제한하거나 사이트 및 앱에 대한 접속을
          금지할 수 있습니다.
        </TermsText>
        <TermsText>
          ⑥ 사이트 또는 앱에 장기간 접속을 하지 않은 회원의 경우 이메일 또는
          공지사항 등을 통한 안내 후 검토 기간을 거쳐 서비스 이용을 중지 또는
          가입을 취소할 수 있습니다.
        </TermsText>
      </TermsSection>

      <TermsSection>
        <TermsSectionTitle>제5조 (정보의 게시 및 관리)</TermsSectionTitle>
        <TermsText>
          ① 누구든지 사이트에 허위 정보, 음란하거나 폭력적인 정보, 다른 사람의
          권리를 침해하는 정보, 기타 법령 및 선량한 사회 질서에 위반하는 정보를
          게시해서는 안됩니다.
        </TermsText>
        <TermsText>
          ② 더 에이치 황해는 회원이 게시한 정보가 제1항에 위배된 정보라고
          판단하는 경우에는 사전 통지 없이 그 정보를 삭제하거나 게시를 거부할 수
          있습니다. 다만 더 에이치 황해가 게시된 모든 정보를 검토할 의무가 있는
          것은 아닙니다.
        </TermsText>
        <TermsText>
          ③ 제1항을 위반하는 정보를 게시함으로 인해 발생한 책임은 전적으로 그
          정보를 게시한 회원이 부담합니다.
        </TermsText>
      </TermsSection>

      <TermsSection>
        <TermsSectionTitle>제6조 (정보로 인한 권리침해)</TermsSectionTitle>
        <TermsText>
          ① 사이트 또는 앱에 게시된 정보로 인한 권리침해를 주장하는 사람 또는
          단체는 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 저작권법 등에
          따라 해당 정보의 삭제를 요청할 수 있습니다. 이 경우 더 에이치 황해는
          관련 법령에 따라 조치합니다.
        </TermsText>
        <TermsText>
          ② 권리침해를 주장하는 사람 또는 단체의 요청이 없더라도 더 에이치
          황해는 관련 법령에 따라 정보에 대해 접근차단 등의 조치를 취할 수
          있습니다.
        </TermsText>
      </TermsSection>

      <TermsSection>
        <TermsSectionTitle>
          제7조 (게시물의 저작권과 저작물의 이용)
        </TermsSectionTitle>
        <TermsText>
          ① 회원이 사이트 또는 앱에 게시한 게시물의 저작권은 그 게시물을 게시한
          회원에게 있습니다.
        </TermsText>
        <TermsText>
          ② 사이트상 게시물은 더 에이치 황해가 제공하는 여러 서비스에 노출될 수
          있습니다. 게시물에 대해 저작권을 가진 회원은 더 에이치 황해에게
          서비스의 제공, 마케팅, 홍보 및 새로운 서비스를 개발하기 위해 필요한
          범위 내에서 사용, 저장, 수정, 복제, 공중송신, 전시, 배포,
          2차저작물작성 등의 방식으로 이용할 수 있도록 그 저작물의 이용을
          허락하는 전 세계적인 라이선스를 제공합니다.
        </TermsText>
        <TermsText>
          ③ 회원은 더 에이치 황해에 제공한 게시물에 대해 더 에이치 황해에
          라이선스를 부여하기 위해 필요한 권리를 보유해야 합니다. 이러한 권리를
          보유하지 않아 발생하는 모든 문제에 대해서는 게시물을 게시한 회원이
          책임을 부담하게 됩니다.
        </TermsText>
      </TermsSection>

      <TermsSection>
        <TermsSectionTitle>제8조 (커뮤니티 이용과 책임)</TermsSectionTitle>
        <TermsText>
          ① 더 에이치 황해는 회원들이 공통의 관심사를 공유할 수 있는 커뮤니티
          서비스를 운영할 수 있습니다.
        </TermsText>
        <TermsText>
          ② 더 에이치 황해는 제4조에 따라 커뮤니티 서비스를 중단할 수 있습니다.
        </TermsText>
        <TermsText>
          ③ 더 에이치 황해는 커뮤니티를 검열할 의무를 부담하지 않으며,
          커뮤니티상의 정보를 관리하지 않습니다. 더 에이치 황해는 커뮤니티에
          관한 책임 및 회원이 커뮤니티에 참여함으로써 발생하는 어떠한 사건에
          대한 책임도 지지 않습니다.
        </TermsText>
        <TermsText>
          ④ 회원은 다른 사람의 권리를 침해하거나 선량한 사회질서에 위반하는 방식
          또는 내용으로 커뮤니티를 개설하여 운영하여서는 아니 됩니다.
        </TermsText>
        <TermsText>
          ⑤ 더 에이치 황해는 커뮤니티가 제3항에 위배되어 운영된다고 판단하는
          경우에는 사전 통지 없이 그 커뮤니티를 삭제하거나 접근을 차단할 수
          있습니다. 다만 더 에이치 황해가 모든 커뮤니티를 검토할 의무가 있는
          것은 아닙니다.
        </TermsText>
      </TermsSection>

      <TermsSection>
        <TermsSectionTitle>제9조 (서비스 이용상의 의무)</TermsSectionTitle>
        <TermsText>
          ① 누구든지 서비스를 이용하면서 다음 각 호의 행위를 해서는 아니 됩니다.
        </TermsText>
        <TermsList>
          <li>
            이용 신청 또는 변경 시 허위 사실을 기재하거나, 다른 사람의 계정 및
            비밀번호를 도용 또는 부정하게 사용하거나, 다른 사람의 명의를
            사용하거나 명의자의 허락 없이 본인확인 등을 수행하는 행위
          </li>
          <li>
            더 에이치 황해의 서비스를 이용하여 얻은 정보를 더 에이치 황해의 사전
            서면 동의 없이 복제 또는 유통시키거나 상업적으로 이용하는 행위
          </li>
          <li>
            다른 사람의 명예를 훼손하거나 허위 사실을 게시하는 등 권리를
            침해하는 행위
          </li>
          <li>
            앱 또는 사이트에 음란물을 게시하거나 음란사이트를 연결(링크)하는
            행위
          </li>
          <li>
            더 에이치 황해 또는 제3자의 저작권 등 기타 권리를 침해하는 행위
          </li>
          <li>
            공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형, 음성 등을
            타인에게 유포하는 행위
          </li>
          <li>
            사이트 또는 앱의 오동작이나 정보 등의 파괴 및 혼란을 유발시킬 수
            있는 행위
          </li>
          <li>
            사이트 또는 앱의 운영을 방해하거나 안정적 운영을 방해할 수 있는 정보
            및 수신자의 명시적인 수신거부의사에 반하여 또는 수신자의 명시적인
            동의 없이 광고성 정보 또는 스팸메일(Spam Mail)을 전송하는 행위
          </li>
          <li>
            더 에이치 황해의 동의 없이 서비스 또는 이에 포함된 소프트웨어의
            일부를 복사, 수정, 배포, 판매, 양도, 대여, 담보제공하거나 타인에게
            그 이용을 허락하는 행위와 소프트웨어를 역설계하거나 소스 코드의
            추출을 시도하는 등 서비스를 복제, 분해 또는 모방하거나 기타 변형하는
            행위
          </li>
          <li>
            타인으로 가장하는 행위 및 타인과의 관계를 허위로 명시하는 행위
          </li>
          <li>서비스 이용자의 개인정보를 수집, 저장, 공개하는 행위</li>
          <li>
            자기 또는 타인에게 재산상의 이익을 주거나 타인에게 손해를 가하는 등
            피해를 입힐 목적으로 허위의 정보를 게시하는 행위
          </li>
          <li>재물을 걸고 도박하거나 사행행위를 하는 행위</li>
          <li>
            윤락행위를 알선하거나 음행을 매개하는 내용의 정보를 유통시키는 행위
          </li>
          <li>
            수치심이나 혐오감 또는 공포심을 일으키는 말이나 음향, 글이나 화상
            또는 영상을 계속하여 상대방에게 도달하게 하여 상대방의 일상적 생활을
            방해하는 행위
          </li>
          <li>
            관련 법령에 의하여 그 전송 또는 게시가 금지되는 정보(컴퓨터 프로그램
            포함)의 전송 또는 게시 행위
          </li>
          <li>
            더 에이치 황해 또는 관계사의 직원이나 운영자를 가장하거나 사칭하여
            또는 타인의 명의를 도용하여 글을 게시하거나 E-mail, 메시지 등을
            발송하는 행위
          </li>
          <li>
            컴퓨터 소프트웨어, 하드웨어, 전기통신 장비의 정상적인 가동을 방해,
            파괴할 가능성이 있는 소프트웨어 바이러스, 기타 다른 컴퓨터 코드,
            파일, 프로그램을 포함하고 있는 자료를 게시하거나 E-mail, 카카오톡
            메시지 등으로 발송하는 행위
          </li>
          <li>
            스토킹(stalking), 허위 또는 악의적 신고 남용 등 다른 이용자를
            괴롭히는 행위
          </li>
          <li>
            기타 현행 법령, 본 약관 및 운영정책 등 더 에이치 황해가 제공하는
            서비스 관련 세부지침을 위반하는 행위
          </li>
        </TermsList>
        <TermsText>
          ② 누구든지 제1항에서 정한 서비스 이용상의 의무 또는 관련 법령을 위반한
          경우에는 서비스 이용이 제한되거나 가입이 취소되거나 재가입이 금지될 수
          있습니다.
        </TermsText>
        <TermsText>
          ③ 회원은 가입 시 제공한 정보가 변경된 경우 사이트를 통하여 변경된
          정보를 더 에이치 황해에 제공하여야 합니다.
        </TermsText>
      </TermsSection>

      <TermsSection>
        <TermsSectionTitle>제10조 (더 에이치 황해의 의무)</TermsSectionTitle>
        <TermsText>
          ① 더 에이치 황해는 법령과 이 약관이 정하는 권리의 행사와 의무의 이행을
          신의에 좇아 성실하게 하여야 합니다.
        </TermsText>
        <TermsText>
          ② 더 에이치 황해는 회원이 안전하게 서비스를 이용할 수 있도록
          개인정보(신용정보 포함)보호를 위해 보안시스템을 갖추어야 하며
          개인정보처리방침을 게시하고 준수합니다.
        </TermsText>
        <TermsText>
          ③ 더 에이치 황해는 서비스를 이용하는 이용자로부터 제기된 의견이나
          불만이 정당하다고 인정할 경우에는 이를 지체없이 처리합니다. 이용자가
          제기한 의견이나 불만사항에 대해서는 전자우편 등을 통하여 그 처리과정
          및 결과를 전달합니다.
        </TermsText>
      </TermsSection>

      <TermsSection>
        <TermsSectionTitle>제11조 (개인정보 보호)</TermsSectionTitle>
        <TermsText>
          ① 더 에이치 황해는 개인정보를 처리하는 경우 관련 법령을 준수합니다.
        </TermsText>
        <TermsText>
          ② 더 에이치 황해는 개인정보처리방침을 수립하여 공개하고, 이를 준수하기
          위해 노력합니다.
        </TermsText>
      </TermsSection>
    </TermsChapter>

    <TermsChapter>
      <TermsChapterTitle>제3장 기타</TermsChapterTitle>

      <TermsSection>
        <TermsSectionTitle>제12조 (손해배상 및 면책)</TermsSectionTitle>
        <TermsText>
          ① 더 에이치 황해는 사이트 및 앱에 정확한 정보를 제공하기 위해
          노력합니다. 그러나 더 에이치 황해는 사이트 및 앱에 게시된 정보, 자료,
          사실의 신뢰도, 정확성 등에 대해 보증하지 않습니다. 누구든지 사이트에
          게시된 정보, 자료 등을 임의로 이용하여 발생한 손해에 대해 더 에이치
          황해에게 책임을 물을 수 없습니다.
        </TermsText>
        <TermsText>
          ② 더 에이치 황해는 서비스 이용에 따라 이용자가 기대하는 어떠한
          이익이나 결과를 보증하지 않습니다. 더 에이치 황해가 제공하는 서비스와
          관련하여 손해가 발생하더라도 더 에이치 황해는 책임을 지지 않습니다.
          다만 황해의 고의에 의한 범죄행위로 인한 경우에는 그로 인해 발생한
          손해에 대해 책임을 부담합니다.
        </TermsText>
        <TermsText>
          ③ 더 에이치 황해는 회원 또는 제3자에 의해 게시된 정보를 승인, 수정,
          반대할 의무가 없습니다. 더 에이치 황해는 서비스 이용자 사이 또는
          서비스 이용자와 제3자 사이에 서비스 이용과 관련하여 발생한 분쟁에 대해
          개입할 의무가 없으며 그와 관련하여 발생한 손해를 배상할 책임이
          없습니다.
        </TermsText>
      </TermsSection>

      <TermsSection>
        <TermsSectionTitle>제13조 (앱과 관련된 소유권)</TermsSectionTitle>
        <TermsText>
          ① 더 에이치 황해가 제공하는 서비스, 그에 필요한 소스코드, 이미지,
          마크, 로고, 디자인, 서비스명칭, 정보 및 상표 등과 관련된 지적재산권
          기타 권리는 더 에이치 황해에 귀속됩니다.
        </TermsText>
        <TermsText>
          ② 누구든지 더 에이치 황해의 사전 서면 동의 없이 더 에이치 황해에
          귀속된 권리를 이용할 수 없습니다.
        </TermsText>
      </TermsSection>

      <TermsSection>
        <TermsSectionTitle>제14조 (분쟁의 해결)</TermsSectionTitle>
        <TermsText>
          서비스를 이용함에 있어 분쟁이 발생한 경우 더 에이치 황해는 이를 원만히
          해결하기 위해 최선을 다합니다. 그럼에도 해결되지 않는 경우 중재법에
          따른 중재에 의한 해결을 시도하며, 중재를 원하지 않는 경우 민사소송법에
          따라 소를 제기할 수 있습니다. 중재 또는 소송에 의한 분쟁해결 시
          준거법은 대한민국 법으로 합니다.
        </TermsText>
      </TermsSection>
    </TermsChapter>

    <TermsFooter>
      공고일자 2025년 12월 2일
      <br />
      시행일자 2025년 12월 2일
    </TermsFooter>
  </TermsContentContainer>
);

// 개인정보 처리방침 JSX 컴포넌트
const PrivacyContent = () => (
  <PrivacyContentContainer>
    <PrivacyIntro>
      개인정보 처리방침
      <br />
      '법무법인 더 에이치 황해' 및 '쿠팡 개인정보 유출 집단소송'(이하 "쿠팡
      개인정보 유출 집단소송")은 「개인정보 보호법」, 「전자상거래 등에서의
      소비자보호에 관한 법률」, 「정보통신망 이용촉진 및 정보보호 등에 관한
      법률」 등 관련 법령에 따라 이용자의 개인정보를 보호하고 개인정보와 관련한
      이용자의 고충을 원활하게 처리할 수 있도록 다음과 같이 개인정보 처리방침을
      수립·공개합니다.
    </PrivacyIntro>

    <PrivacySection>
      <PrivacySectionTitle>제1조 (개인정보의 처리 목적)</PrivacySectionTitle>
      <PrivacyText>
        쿠팡 유출 피해자들은 서비스 이용에 필수적인 개인정보를 다음과 같은
        목적을 위하여 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의
        용도로는 이용되지 않으며, 처리 목적과 항목이 변경되는 경우에는 사전에
        이용자의 동의를 받습니다.
      </PrivacyText>
      <PrivacyText>1. 서비스 제공 및 요금 정산</PrivacyText>
      <PrivacyList>
        <li>
          쿠팡(Coupang) 개인정보 유출 손해배상소제기 신청서 및 관련 서류 작성 및
          신청 대행
        </li>
        <li>정기/비정기 이용료 자동 또는 수동 결제</li>
        <li>미지급 이용료, 비용에 대한 청구 및 법적 절차 진행</li>
      </PrivacyList>
      <PrivacyText>2. 회원 관리</PrivacyText>
      <PrivacyList>
        <li>본인 확인 및 회원 식별</li>
        <li>부정 이용 방지 및 비인가 사용 방지</li>
        <li>
          불만 및 민원처리, 고지사항 전달, 광고성 정보 제공 및 참여 기회 제공
        </li>
        <li>이용 기록 분석 및 통계 분석</li>
      </PrivacyList>
    </PrivacySection>

    <PrivacySection>
      <PrivacySectionTitle>
        제2조 (개인정보의 수집 및 처리 항목)
      </PrivacySectionTitle>
      <PrivacyText>
        쿠팡 개인정보 유출 집단소송은 서비스 제공을 위해 아래와 같은 정보를
        처리합니다.
      </PrivacyText>
      <PrivacyText>
        1. IP 주소, 쿠키, 방문 일시, 서비스 이용 기록, 불량 이용 기록, 기기정보
      </PrivacyText>
      <PrivacyText>2. 결제 서비스 이용 중 생성되는 정보</PrivacyText>
      <PrivacyText>3. 고객 상담 중 생성되는 정보</PrivacyText>
      <PrivacyTableWrapper>
        <PrivacyTable>
          <thead>
            <tr>
              <th>구분</th>
              <th>동의구분</th>
              <th>수집/처리항목</th>
              <th>수집/처리목적</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>회원가입 시</td>
              <td>필수</td>
              <td>
                성명, 생년월일, 개인식별정보(CI/DI), 주민등록번호(13자리), 주소,
                연락처, 계좌 정보(은행명, 계좌번호, 예금주명), 전자서명, 신분증
                사본, 피해 내용 및 관련 증빙자료
              </td>
              <td>
                회원 식별 및 관리, 고객 상담 및 민원 처리, 광고성 정보 제공,
                판결금 및 보상금 정산 등
              </td>
            </tr>
            <tr>
              <td>쿠팡 손해배상 신청</td>
              <td>필수</td>
              <td>
                피해 정보, 쿠팡 계정 정보(ID 등), 구매/이용 내역, 신상 정보
              </td>
              <td>소장 및 관련 서류 작성, 소제기 대리</td>
            </tr>
            <tr>
              <td>서비스 이용 시</td>
              <td>자동 수집</td>
              <td>IP 주소, 방문 기록, 기기 정보, 서비스 이용 기록</td>
              <td>서비스 개선 및 이용 분석</td>
            </tr>
            <tr>
              <td>결제 서비스 이용</td>
              <td>-</td>
              <td>결제 관련 생성 정보</td>
              <td>요금 결제 및 정산</td>
            </tr>
          </tbody>
        </PrivacyTable>
      </PrivacyTableWrapper>
    </PrivacySection>

    <PrivacySection>
      <PrivacySectionTitle>제3조 (개인정보 수집 방법)</PrivacySectionTitle>
      <PrivacyText>
        쿠팡 개인정보 유출 집단소송은 다음과 같은 방법으로 개인정보를
        수집합니다.
      </PrivacyText>
      <PrivacyList>
        <li>회원가입 및 서비스 이용 과정에서 이용자가 직접 입력한 정보</li>
        <li>상담 및 민원 처리 과정에서 생성되는 정보</li>
        <li>서비스 이용 과정에서 자동으로 수집되는 정보 (IP, 쿠키 등)</li>
      </PrivacyList>
    </PrivacySection>

    <PrivacySection>
      <PrivacySectionTitle>
        제4조 (개인정보의 보유 및 이용 기간)
      </PrivacySectionTitle>
      <PrivacyText>
        쿠팡 개인정보 유출 집단소송은 이용자가 동의한 개인정보 보유 기간 내에서
        개인정보를 처리합니다. 회원이 탈퇴하거나 개인정보 수집·이용에 대한
        동의를 철회하는 경우, 수집 목적이 달성되거나 보유 기간이 종료한 경우에는
        해당 정보를 지체 없이 파기합니다. 단, 법령에 따라 일정 기간 보관이
        필요한 경우에는 다음과 같이 보관됩니다.
      </PrivacyText>
      <PrivacyTableWrapper>
        <PrivacyTable>
          <thead>
            <tr>
              <th>법령</th>
              <th>항목</th>
              <th>보유기간</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>전자상거래법</td>
              <td>소비자 불만 또는 분쟁 처리 기록</td>
              <td>3년</td>
            </tr>
            <tr>
              <td>전자상거래법</td>
              <td>계약 및 청약철회 기록</td>
              <td>5년</td>
            </tr>
            <tr>
              <td>전자상거래법</td>
              <td>대금결제 및 공급 기록</td>
              <td>5년</td>
            </tr>
            <tr>
              <td>국세기본법</td>
              <td>세법상 거래 기록</td>
              <td>5년</td>
            </tr>
            <tr>
              <td>전자금융거래법</td>
              <td>전자금융 거래 기록</td>
              <td>5년</td>
            </tr>
            <tr>
              <td>표시·광고 공정화법</td>
              <td>표시/광고에 대한 기록</td>
              <td>6개월</td>
            </tr>
          </tbody>
        </PrivacyTable>
      </PrivacyTableWrapper>
    </PrivacySection>

    <PrivacySection>
      <PrivacySectionTitle>제5조 (개인정보의 위탁)</PrivacySectionTitle>
      <PrivacyText>
        쿠팡 유출 피해자들은 원활한 서비스 제공을 위해 개인정보 처리 업무를
        다음과 같이 위탁하고 있으며, 안전한 관리가 이루어질 수 있도록 필요한
        조치를 취하고 있습니다.
      </PrivacyText>
      <PrivacyTableWrapper>
        <PrivacyTable>
          <thead>
            <tr>
              <th>수탁업체</th>
              <th>위탁업무 내용</th>
              <th>보유 및 이용 기간</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>법무법인 더 에이치 황해</td>
              <td>회원 정보의 처리 및 보관</td>
              <td>위탁 계약 종료 시까지</td>
            </tr>
            <tr>
              <td>법무법인 더 에이치 황해</td>
              <td>피해사실 증명서 발급</td>
              <td>위탁 계약 종료 시까지</td>
            </tr>
          </tbody>
        </PrivacyTable>
      </PrivacyTableWrapper>
    </PrivacySection>

    <PrivacySection>
      <PrivacySectionTitle>제6조 (개인정보 제3자 제공)</PrivacySectionTitle>
      <PrivacyText>
        쿠팡 개인정보 유출 집단소송은 이용자의 개인정보를 원칙적으로 외부에
        제공하지 않습니다. 다만, 법령에 따라 요청이 있거나 이용자의 별도 동의가
        있는 경우 제공될 수 있습니다.
      </PrivacyText>
    </PrivacySection>

    <PrivacySection>
      <PrivacySectionTitle>제7조 (이용자의 권리와 의무)</PrivacySectionTitle>
      <PrivacyText>
        1. 이용자는 언제든지 본인의 개인정보를 조회, 수정 및 삭제할 수 있습니다.
      </PrivacyText>
      <PrivacyText>
        2. 법정대리인이나 위임을 받은 자를 통해 권리를 행사할 수 있으며, 이 경우
        위임장을 제출해야 합니다.
      </PrivacyText>
      <PrivacyText>
        3. 만 14세 미만 아동의 개인정보는 수집하지 않습니다.
      </PrivacyText>
      <PrivacyText>
        4. 이용자가 타인의 정보를 도용하거나 허위 정보를 입력하는 경우,
        회원자격이 상실될 수 있으며 법적 처벌을 받을 수 있습니다.
      </PrivacyText>
    </PrivacySection>

    <PrivacySection>
      <PrivacySectionTitle>
        제8조 (개인정보 자동 수집 및 거부)
      </PrivacySectionTitle>
      <PrivacyText>
        1. 서비스 이용 과정에서 쿠키 및 기기 정보가 자동으로 수집될 수 있습니다.
      </PrivacyText>
      <PrivacyText>
        2. 이용자는 브라우저 설정을 통해 쿠키를 차단할 수 있으나, 일부 서비스
        이용이 제한될 수 있습니다.
      </PrivacyText>
    </PrivacySection>

    <PrivacySection>
      <PrivacySectionTitle>제9조 (개인정보의 파기)</PrivacySectionTitle>
      <PrivacyText>
        1. 쿠팡 개인정보 유출 집단소송은 개인정보 보유기간이 경과하거나
        처리목적이 달성되었을 때에는 지체 없이 해당 개인정보를 파기합니다.
      </PrivacyText>
      <PrivacyText>
        2. 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고
        다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당
        개인정보를 별도의 데이터베이스로 옮기거나 보관장소를 달리하여
        보존합니다.
      </PrivacyText>
      <PrivacyText>
        3. 개인정보 파기의 절차 및 방법은 다음과 같습니다.
      </PrivacyText>
      <PrivacyText style={{ marginLeft: "16px" }}>
        a. 파기절차: 파기 사유가 발생한 개인정보를 선정하고 아래 방법에 따라
        파기합니다.
      </PrivacyText>
      <PrivacyText style={{ marginLeft: "16px" }}>
        b. 파기방법: 전자적 파일 형태는 복구 및 재생되지 않도록 기술적 방법을
        사용하여 파기하며, 종이 문서는 분쇄하거나 소각하여 파기합니다.
      </PrivacyText>
      <PrivacyText style={{ marginLeft: "16px" }}>
        c. 쿠팡 개인정보 유출 집단소송은 개인정보 보호법 제39조의6에 따라 장기
        미이용자에 관한 정책을 다음과 같이 유지하고 있습니다.
      </PrivacyText>
      <PrivacyText style={{ marginLeft: "16px" }}>
        d. 최근 1년 동안 이용 기록이 없는 회원(장기 미이용자)의 개인정보는
        별도로 분리하여 안전하게 관리하게 되며, 대상자에게는 분리 보관 처리일을
        기준으로 하여 최소 30일 이전에 이메일 주소를 통해 안내를 합니다. 단,
        통신비밀보호법, 전자상거래 등에서의 소비자보호에 관한 법률 등의
        관계법령의 규정에 의하여 보존할 필요가 있는 경우 규정된 기간 동안
        이용자의 개인정보를 보관합니다.
      </PrivacyText>
    </PrivacySection>

    <PrivacySection>
      <PrivacySectionTitle>제10조 (개인정보 보호조치)</PrivacySectionTitle>
      <PrivacyText>
        쿠팡 개인정보 유출 집단소송은 개인정보 보호를 위해 다음과 같은 조치를
        취합니다.
      </PrivacyText>
      <PrivacyList>
        <li>관리적 조치: 내부 관리계획 수립 및 직원 교육</li>
        <li>기술적 조치: 접근권한 관리, 암호화 및 보안 프로그램 운영</li>
        <li>물리적 조치: 서버 및 자료 보관소 접근 통제</li>
      </PrivacyList>
    </PrivacySection>

    <PrivacySection>
      <PrivacySectionTitle>제11조 (개인정보 보호 책임자)</PrivacySectionTitle>
      <PrivacyText>
        회사는 귀하가 좋은 정보를 안전하게 이용할 수 있도록 최선을 다하고
        있습니다. 이용자 개인정보와 관련한 아이디(ID)의 비밀번호에 대한
        보안유지책임은 해당 이용자 자신에게 있습니다. 회사는 비밀번호에 대해
        어떠한 방법으로도 이용자에게 직접적으로 질문하는 경우는 없으므로
        타인에게 비밀번호가 유출되지 않도록 각별히 주의하시기 바랍니다. 특히
        공공장소에서 온라인상에서 접속해 있을 경우에는 더욱 유의하셔야 합니다.
      </PrivacyText>
      <PrivacyText>
        쿠팡 개인정보 유출 집단소송은 개인정보 보호 책임자를 다음과 같이
        지정하고 있습니다.
      </PrivacyText>
      <PrivacyContactInfo>
        <strong>개인정보 보호 책임자 / 담당자</strong>
        <br />
        이름: 천상현
        <br />
        전화: 032-251-1000
        <br />
        이메일: theh1000@lfthe-h.com
      </PrivacyContactInfo>
      <PrivacyText>
        기타 개인정보 침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에
        문의하시기 바랍니다.
      </PrivacyText>
      <PrivacyList>
        <li>개인정보침해 신고센터: 국번 없이 118 (privacy.kisa.or.kr)</li>
        <li>개인정보 분쟁조정위원회: 1833-6972 (kopico.go.kr)</li>
        <li>대검찰청 사이버수사과: 국번 없이 130 (spo.go.kr)</li>
        <li>경찰청 사이버수사국: 국번 없이 182 (ecrm.police.go.kr)</li>
      </PrivacyList>
    </PrivacySection>

    <PrivacySection>
      <PrivacySectionTitle>제12조 (고지의 의무)</PrivacySectionTitle>
      <PrivacyText>
        본 개인정보 처리방침은 관련 법령 및 정책 변경에 따라 개정될 수 있으며,
        변경 사항 발생 시 최소 7일 전에 공지합니다.
      </PrivacyText>
      <PrivacyFooter>
        부칙
        <br />본 개인정보 처리방침은 2025년 12월 2일부터 적용됩니다.
      </PrivacyFooter>
    </PrivacySection>
  </PrivacyContentContainer>
);

// 마케팅 수신 동의 JSX 컴포넌트
const MarketingContent = () => (
  <MarketingContentContainer>
    <MarketingIntro>
      마케팅 수신 동의
      <br />
      법무법인 더 에이치 황해(이하 "법인")은 「정보통신망 이용촉진 및 정보보호
      등에 관한 법률」, 「개인정보보호법」 등 관련 법령에 따라 광고성 정보
      전송을 위해 사전 동의를 받고 있습니다. 동의하지 않으시더라도 서비스
      이용에는 제한이 없으나, 법인이 제공하는 혜택·소식·이벤트 등의 안내를 받기
      어려울 수 있습니다.
    </MarketingIntro>

    <MarketingSection>
      <MarketingSectionTitle>1. 수집·이용 목적</MarketingSectionTitle>
      <MarketingText>
        문자메시지, 알림톡 등을 통한 광고성 정보 및 이벤트 안내
      </MarketingText>
      <MarketingText>
        법무법인 더 에이치 황해의 서비스 소개, 소식, 혜택, 행사 등 마케팅 활용
      </MarketingText>
      <MarketingText>
        단, 소송 진행 및 법률 서비스 제공을 위한 필수 안내는 동의 여부와
        무관하게 제공됩니다.
      </MarketingText>
    </MarketingSection>

    <MarketingSection>
      <MarketingSectionTitle>2. 수집·이용 항목</MarketingSectionTitle>
      <MarketingText>휴대전화번호</MarketingText>
    </MarketingSection>

    <MarketingSection>
      <MarketingSectionTitle>3. 보유·이용 기간</MarketingSectionTitle>
      <MarketingText>
        동의일로부터 동의 철회 또는 서비스 탈퇴 시까지
      </MarketingText>
    </MarketingSection>

    <MarketingSection>
      <MarketingSectionTitle>4. 안내사항</MarketingSectionTitle>
      <MarketingText>
        본 동의는 선택 사항이며, 미동의 시에도 서비스 이용에는 제한이 없습니다.
      </MarketingText>
      <MarketingText>
        수신 동의 또는 철회는 언제든지 고객지원 채널을 통해 변경할 수 있습니다.
      </MarketingText>
    </MarketingSection>
  </MarketingContentContainer>
);

// 커스텀 옵션 컴포넌트
const CustomOption = ({ innerProps, label, data, isDisabled }) => {
  // isDisabled가 없으면 data에서 가져오기
  const disabled =
    isDisabled !== undefined ? isDisabled : data?.isDisabled || false;
  const isPreparing = data?.isPreparing || false;

  return (
    <OptionContainer {...innerProps} $isDisabled={disabled}>
      {data.icon && (
        <AuthIcon src={data.icon} alt={label} $isDisabled={disabled} />
      )}
      <OptionTextContainer>
        <OptionLabel $isDisabled={disabled}>{label}</OptionLabel>
        {isPreparing && <PreparingText>준비중입니다</PreparingText>}
      </OptionTextContainer>
    </OptionContainer>
  );
};

// 커스텀 단일 값 컴포넌트
const CustomSingleValue = ({ children, data }) => (
  <SingleValueContainer>
    {data.icon && <AuthIcon src={data.icon} alt={children} />}
    <span>{children}</span>
  </SingleValueContainer>
);

const IdentityVerificationInputPage = () => {
  const { navigateTo } = useContext(DirectionContext);
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [birthDateFront, setBirthDateFront] = useState(""); // 주민번호 앞 6자리
  const [birthDateBack, setBirthDateBack] = useState(""); // 주민번호 뒷 7자리
  const [residentNumberError, setResidentNumberError] = useState(""); // 주민번호 뒷자리 에러 메시지
  const [authMethod, setAuthMethod] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [isPolling, setIsPolling] = useState(false);
  const [showAgreementModal, setShowAgreementModal] = useState(false);
  const [agreements, setAgreements] = useState({
    terms: false,
    privacy: false,
    marketing: false,
  });
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showMarketingModal, setShowMarketingModal] = useState(false);
  const [showNoAuthMethodModal, setShowNoAuthMethodModal] = useState(false);
  const [showMismatchModal, setShowMismatchModal] = useState(false);
  const [showAlreadyCompletedModal, setShowAlreadyCompletedModal] =
    useState(false);

  // 외국인 알림을 위한 별도의 토스트 상태
  const [showToast2, setShowToast2] = useState(false);
  const [toastMessage2, setToastMessage2] = useState("");

  // ref 추가
  const birthDateRef = useRef(null);
  const birthDateBackRef = useRef(null); // 주민번호 뒷자리 ref
  const pollingIntervalRef = useRef(null);
  const pollingCountRef = useRef(0); // 폴링 횟수 추적

  // 페이지 로드 시 스크롤 위치를 맨 위로 초기화
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, []);

  // 컴포넌트 언마운트 시 폴링 정리
  useEffect(() => {
    return () => {
      stopStatusPolling();
    };
  }, []);

  // 애니메이션 변수
  const pageVariants = {
    initial: {
      opacity: 0,
    },
    in: {
      opacity: 1,
      transition: {
        duration: 0.5,
      },
    },
    out: {
      opacity: 0,
      transition: {
        duration: 0.3,
      },
    },
  };

  const contentVariants = {
    initial: {
      opacity: 0,
      y: 20,
    },
    in: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        delay: 0.2,
        staggerChildren: 0.1,
      },
    },
  };

  // 외국인 알림 토스트 메시지 표시 함수
  const showForeignerToast = () => {
    setToastMessage2("외국인은 접수를 받지 않습니다");
    setShowToast2(true);
    setTimeout(() => {
      setShowToast2(false);
    }, 3000);
  };

  // 영어 문자 확인 함수
  const containsEnglish = (text) => {
    return /[a-zA-Z]/.test(text);
  };

  // 생년월일 유효성 검증 함수
  const validateBirthDate = (birthDateStr) => {
    if (birthDateStr.length !== 8) {
      return { isValid: false, message: "생년월일을 8자리로 입력해주세요" };
    }

    const year = parseInt(birthDateStr.substring(0, 4));
    const month = parseInt(birthDateStr.substring(4, 6));
    const day = parseInt(birthDateStr.substring(6, 8));

    // 연도 유효성 검증 (1900년 이후, 현재 연도 이하)
    const currentYear = new Date().getFullYear();
    if (year < 1900 || year > currentYear) {
      return { isValid: false, message: "올바른 생년월일을 입력해주세요" };
    }

    // 월 유효성 검증 (1-12)
    if (month < 1 || month > 12) {
      return { isValid: false, message: "올바른 생년월일을 입력해주세요" };
    }

    // 일 유효성 검증
    const daysInMonth = new Date(year, month, 0).getDate();
    if (day < 1 || day > daysInMonth) {
      return { isValid: false, message: "올바른 생년월일을 입력해주세요" };
    }

    // 미래 날짜 체크
    const birthDate = new Date(year, month - 1, day);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (birthDate > today) {
      return { isValid: false, message: "미래 날짜는 입력할 수 없습니다" };
    }

    // 미성년자 체크 (현재 연도 기준으로 19세 미만이면 접수 불가)
    const age = currentYear - year;
    // 생일이 지났는지 확인
    const currentMonth = new Date().getMonth() + 1;
    const currentDay = new Date().getDate();
    const actualAge =
      currentMonth > month || (currentMonth === month && currentDay >= day)
        ? age
        : age - 1;

    if (actualAge < 19) {
      return { isValid: false, message: "미성년자는 접수를 받지 않습니다" };
    }

    return { isValid: true, message: "" };
  };

  // 생년월일 입력 핸들러 (8자리만 입력)
  const handleBirthDateChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "").slice(0, 8);
    setBirthDate(value);

    // 8자리 입력되면 유효성 검증 및 주민번호 앞자리 자동 입력
    if (value.length === 8) {
      // 생년월일 유효성 검증
      const validation = validateBirthDate(value);

      if (!validation.isValid) {
        setToastMessage2(validation.message);
        setShowToast2(true);
        setTimeout(() => {
          setShowToast2(false);
        }, 3000);
        // 생년월일 초기화
        setBirthDate("");
        setBirthDateFront("");
        return;
      }

      // 유효한 생년월일이면 주민번호 앞자리 자동 입력 - 주석 처리 (주민등록번호 입력 필드 비활성화)
      // const frontPart = value.substring(2, 8); // YYYYMMDD에서 YYMMDD 추출
      // setBirthDateFront(frontPart);

      e.target.blur();
      // 주민번호 뒷자리 입력 필드로 포커스 이동 - 주석 처리 (주민등록번호 입력 필드 비활성화)
      // setTimeout(() => {
      //   if (birthDateBackRef.current) {
      //     birthDateBackRef.current.focus();
      //   }
      // }, 100);
    } else {
      // 생년월일이 8자리가 아니면 주민번호 앞자리 초기화
      setBirthDateFront("");
    }
  };

  // 휴대폰 번호 입력 핸들러
  const handlePhoneNumberChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "").slice(0, 11);
    setPhoneNumber(value);

    // 11자리 입력되면 생년월일 인풋으로 포커스 이동
    if (value.length === 11 && birthDateRef.current) {
      setTimeout(() => {
        birthDateRef.current?.focus();
      }, 100);
    }
  };

  // 인증수단 선택 핸들러
  const handleAuthMethodChange = (selectedOption) => {
    if (selectedOption && selectedOption.value === "none") {
      // "인증이 불가해요" 선택 시 모달 표시
      setShowNoAuthMethodModal(true);
    } else {
      setAuthMethod(selectedOption);
    }
  };

  // 인증수단 없음 모달 확인 핸들러 (예 버튼)
  const handleNoAuthMethodConfirm = () => {
    setShowNoAuthMethodModal(false);
    setAuthMethod({
      value: "none",
      label: "인증이 불가해요",
      icon: "/png/noIcon.png",
    });
  };

  // 이미 신청 완료 모달 확인 핸들러
  const handleAlreadyCompletedConfirm = () => {
    setShowAlreadyCompletedModal(false);
    // 토큰 삭제
    Cookies.remove(API_ENDPOINTS.COOKIE_CONFIG.KEYS.ACCESS_TOKEN);
    navigateTo("/select");
  };

  // 인증수단 없음 모달 취소 핸들러 (아니오 버튼)
  const handleNoAuthMethodCancel = () => {
    setShowNoAuthMethodModal(false);
    setAuthMethod(null); // 인증수단 초기화
  };

  // 다음 버튼 활성화 여부
  const isNextButtonEnabled =
    name.trim() !== "" &&
    phoneNumber.length === 11 &&
    birthDate.length === 8 &&
    // birthDateBack.length === 7 && // 주민등록번호 입력 필드 주석 처리로 인해 제거
    // residentNumberError === "" && // 주민등록번호 입력 필드 주석 처리로 인해 제거
    authMethod !== null;

  // 동의 모달에서 다음 버튼 활성화 여부
  const isAgreementNextEnabled = agreements.terms && agreements.privacy;

  // 동의 체크박스 토글
  const handleAgreementToggle = (key) => {
    setAgreements((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  // 동의 모달에서 다음 버튼 클릭
  const handleAgreementNext = () => {
    if (agreements.terms && agreements.privacy) {
      setShowAgreementModal(false);

      // 개인정보처리방침/이용약관/마케팅 동의는 본인인증 단계에서 받고,
      // 신청서 생성(POST /applications) 후 PATCH로 서버에 반영하기 위해 localStorage에 임시 저장
      localStorage.setItem(
        "termsAgreements",
        JSON.stringify({
          hasAgreedToTermsOfUse: agreements.terms,
          hasAgreedToPrivacyCollection: agreements.privacy,
          hasAgreedToMarketing: agreements.marketing,
        }),
      );

      // "인증이 불가해요" 선택한 경우
      if (authMethod && authMethod.value === "none") {
        // 쿠키에 데이터 저장
        Cookies.set("pendingVerificationName", name, { expires: 7, path: "/" });
        Cookies.set("pendingVerificationPhone", phoneNumber, {
          expires: 7,
          path: "/",
        });
        Cookies.set("pendingVerificationBirthDate", birthDate, {
          expires: 7,
          path: "/",
        });
        // 주민등록번호 앞자리와 뒷자리도 쿠키에 저장 - 주석 처리
        // Cookies.set("pendingVerificationBirthDateFront", birthDateFront, {
        //   expires: 7,
        //   path: "/",
        // });
        // Cookies.set("pendingVerificationBirthDateBack", birthDateBack, {
        //   expires: 7,
        //   path: "/",
        // });

        // /lawyer-verification으로 이동
        navigateTo("/lawyer-verification");
        return;
      }

      // 모든 경우에서 입력한 이름을 쿠키에 저장 (예금주명 검증용)
      Cookies.set("pendingVerificationName", name, { expires: 7, path: "/" });

      // 실제 본인인증 API 호출
      handleIdentityVerification();
    }
  };

  // 본인인증 API 호출
  const handleIdentityVerification = async () => {
    setIsLoading(true);
    setError("");

    try {
      // certificationType을 대문자로 변환 (KAKAO, NAVER, TOSS)
      const certificationType = authMethod.value.toUpperCase();

      // 1. 본인인증 요청
      const requestResponse = await fetch(
        `${API_ENDPOINTS.BASE_URL}/clients/request-identity`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            receiverHP: phoneNumber,
            receiverName: name,
            receiverBirthdate: birthDate,
            certificationType: certificationType,
            lawsuitId: 2,
          }),
        },
      );

      // 500 에러 체크
      if (requestResponse.status === 500) {
        setIsLoading(false);
        setShowMismatchModal(true);
        return;
      }

      const requestData = await requestResponse.json();

      if (!requestData.success || !requestData.receiptID) {
        throw new Error(requestData.message || "본인인증 요청에 실패했습니다.");
      }

      const receiptID = requestData.receiptID;

      // 2. 본인인증 상태 확인 폴링 시작
      startStatusPolling(receiptID, certificationType);
    } catch (error) {
      console.error("본인인증 오류:", error);
      setError(error.message || "본인인증 중 오류가 발생했습니다.");
      setIsLoading(false);
      stopStatusPolling();
    }
  };

  // 본인인증 상태 폴링 시작
  const startStatusPolling = (receiptID, certificationType) => {
    // 기존 폴링이 있으면 정지
    stopStatusPolling();

    // 상태 설정
    setIsLoading(true);
    setIsPolling(true);

    // 폴링 횟수 초기화
    pollingCountRef.current = 0;

    // 3초마다 본인인증 상태 확인
    pollingIntervalRef.current = setInterval(() => {
      checkIdentityVerificationStatus(receiptID, certificationType);
    }, 3000);

    // 첫 번째 확인 즉시 실행
    checkIdentityVerificationStatus(receiptID, certificationType);
  };

  // 본인인증 상태 폴링 중지
  const stopStatusPolling = () => {
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
      pollingIntervalRef.current = null;
    }
    setIsPolling(false);
  };

  // 본인인증 상태 확인
  const checkIdentityVerificationStatus = async (
    receiptID,
    certificationType,
  ) => {
    // 폴링 횟수 증가
    pollingCountRef.current += 1;

    // 최대 30회 초과 시 폴링 중지
    if (pollingCountRef.current > 30) {
      stopStatusPolling();
      setIsLoading(false);
      setError("본인인증 확인 시간이 초과되었습니다. 다시 시도해주세요.");
      return;
    }

    try {
      const applicationType = Cookies.get("applicationType") || "self";
      const verifyResponse = await fetch(
        `${
          API_ENDPOINTS.BASE_URL
        }/clients/identity-status/${receiptID}?certificationType=${certificationType}&applicationType=${
          applicationType === "representative" ? "REPRESENTATIVE" : "INDIVIDUAL"
        }&lawsuitId=2`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (!verifyResponse.ok) {
        // 네트워크 오류 등의 일시적인 문제는 폴링 유지
        return;
      }

      const verifyData = await verifyResponse.json();

      if (!verifyData.success) {
        // 오류가 발생한 경우 폴링 중지
        stopStatusPolling();
        setIsLoading(false);
        setError(verifyData.message || "본인인증 확인 중 오류가 발생했습니다.");
        // "잘못된 접근입니다." 메시지일 때 쿼리 파라미터 추가
        if (verifyData.message === "잘못된 접근입니다.") {
          navigateTo("/?joint=true");
        } else {
          navigateTo("/");
        }
        return;
      }

      if (verifyData.isCompleted && verifyData.success) {
        // 본인인증 완료 - 토큰 저장 후 다음 페이지로 이동
        if (verifyData.token) {
          // 토큰을 쿠키에 저장
          Cookies.set(
            API_ENDPOINTS.COOKIE_CONFIG.KEYS.ACCESS_TOKEN,
            verifyData.token,
            {
              expires: API_ENDPOINTS.COOKIE_CONFIG.EXPIRES.ACCESS_TOKEN,
              ...API_ENDPOINTS.COOKIE_CONFIG.OPTIONS,
            },
          );

          // 휴대폰 번호를 숫자만 추출하여 쿠키에 저장 (NewsProofSubmission에서 검증에 사용)
          const normalizedPhone = String(phoneNumber).replace(/[^0-9]/g, "");
          Cookies.set("verifiedPhoneNumber", normalizedPhone, {
            expires: 7,
            ...API_ENDPOINTS.COOKIE_CONFIG.OPTIONS,
          });

          // 토큰 저장 후 /clients/me GET으로 신청 완료 여부 확인
          try {
            const getResponse = await fetch(
              `${API_ENDPOINTS.BASE_URL}/clients/me`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${verifyData.token}`,
                },
              },
            );

            if (getResponse.ok) {
              const userData = await getResponse.json();

              // 이미 집단소송 신청을 완료한 경우 확인 (applications 배열에서 확인)
              const hasCompletedApplication =
                userData.applications &&
                userData.applications.some(
                  (app) =>
                    app.lawsuitId === 2 && app.status === "PAYMENT_COMPLETED",
                );

              if (hasCompletedApplication) {
                // 이미 신청 완료한 경우 모달 표시
                stopStatusPolling();
                setIsLoading(false);
                setShowAlreadyCompletedModal(true);
                return;
              }
            }
          } catch (error) {
            console.error("사용자 정보 조회 중 오류:", error);
          }

          // 신청 완료하지 않은 경우에만 PATCH API 호출
          try {
            // PATCH 요청 body 구성 (백엔드에서 빠진 필드는 전송하지 않음)
            const putBody = {};

            // /clients/me PATCH API 호출
            const putResponse = await fetch(
              `${API_ENDPOINTS.BASE_URL}/clients/me`,
              {
                method: "PATCH",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${verifyData.token}`,
                },
                body: JSON.stringify(putBody),
              },
            );

            if (!putResponse.ok) {
              console.error(
                "사용자 정보 업데이트 실패:",
                await putResponse.text(),
              );
            }
          } catch (error) {
            console.error("사용자 정보 업데이트 중 오류:", error);
          }
        }
        stopStatusPolling();
        setIsLoading(false);
        navigateTo("/user-data");
      } else {
        // 본인인증이 아직 완료되지 않음 - 폴링 계속
        // 폴링 상태 유지 (isPolling은 이미 true)
      }
    } catch (error) {
      // 네트워크 오류 등의 일시적인 문제는 폴링 유지
      console.error("본인인증 상태 확인 오류:", error);
    }
  };

  return (
    <PageBackground>
      <GlobalSelectStyles />
      <AnimatePresence>
        {isPolling && (
          <PollingOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <PollingModal
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
            >
              <Spinner />
              <PollingIndicatorText>
                {authMethod?.value === "naver"
                  ? "네이버 본인인증이 도착했습니다."
                  : authMethod?.value === "toss"
                    ? "토스 본인인증이 도착했습니다."
                    : "카카오톡 본인인증이 도착했습니다."}
                <br />
                {authMethod?.value === "naver"
                  ? "네이버에서 인증을 완료하고 돌아와주세요."
                  : authMethod?.value === "toss"
                    ? "토스에서 인증을 완료하고 돌아와주세요."
                    : "카카오톡에서 인증을 완료하고 돌아와주세요."}
              </PollingIndicatorText>
            </PollingModal>
          </PollingOverlay>
        )}
      </AnimatePresence>
      <Container
        variants={pageVariants}
        initial="initial"
        animate="in"
        exit="out"
      >
        <Content variants={contentVariants} initial="initial" animate="in">
          <Header>
            <SubTitle>본인인증 정보를 입력해주세요</SubTitle>
            <Description>본인인증에 필요한 내역을 작성해주세요</Description>
          </Header>

          {/* 안내문구 */}
          <InfoBox>
            <InfoIcon>ⓘ</InfoIcon>
            <InfoText>
              본 신청은 미성년자와 외국인은 접수받지 않습니다.
            </InfoText>
          </InfoBox>

          {/* 본인 인증 정보 입력 섹션 */}
          <VerificationSection>
            <SectionTitle>본인 인증 정보입력</SectionTitle>
            <FormGroup>
              <Label>
                이름<Required>*</Required>
              </Label>
              <Input
                type="text"
                placeholder="이름을 입력해주세요"
                value={name}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  setName(inputValue);

                  // 영어 문자가 포함되어 있으면 외국인으로 간주하고 토스트 표시
                  if (containsEnglish(inputValue)) {
                    showForeignerToast();
                    // 이름 초기화
                    setName("");
                  }
                }}
              />
            </FormGroup>

            <FormGroup>
              <Label>
                휴대폰 번호<Required>*</Required>
              </Label>
              <Input
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="휴대폰 번호를 입력해주세요"
                value={phoneNumber}
                onChange={handlePhoneNumberChange}
                isNumeric
              />
            </FormGroup>

            <FormGroup>
              <Label>
                생년월일<Required>*</Required>
              </Label>
              <Input
                ref={birthDateRef}
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="생년월일을 입력해주세요 (YYYYMMDD)"
                value={birthDate}
                onChange={handleBirthDateChange}
                maxLength={8}
                isNumeric
              />
            </FormGroup>

            {/* 주민등록번호 입력 필드 - 주석 처리 */}
            {/* <FormGroup>
              <Label>
                주민등록번호<Required>*</Required>
              </Label>
              <ResidentNumberContainer>
                <ResidentNumberInput
                  type="text"
                  autoComplete="off"
                  placeholder="YYMMDD"
                  value={birthDateFront}
                  readOnly
                  style={{
                    backgroundColor: "#f5f5f5",
                    cursor: "not-allowed",
                  }}
                />
                <ResidentNumberInput
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  autoComplete="off"
                  placeholder="주민번호 뒷 7자리"
                  value={
                    birthDateBack.length === 0
                      ? ""
                      : birthDateBack.length === 7
                      ? "•••••••"
                      : birthDateBack.length === 1
                      ? birthDateBack
                      : "•".repeat(birthDateBack.length - 1) +
                        birthDateBack[birthDateBack.length - 1]
                  }
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    // 마스킹 문자(•)를 제거하고 숫자만 추출
                    const numericValue = inputValue
                      .replace(/[^0-9]/g, "")
                      .slice(0, 7);

                    // 이전 값과 비교하여 실제로 변경된 경우에만 업데이트
                    if (numericValue !== birthDateBack) {
                      setBirthDateBack(numericValue);

                      // 주민번호 뒷자리 첫 번째 자리 검증 (1, 2, 3, 4로 시작해야 함)
                      if (numericValue.length > 0) {
                        const firstDigit = numericValue[0];
                        if (!["1", "2", "3", "4"].includes(firstDigit)) {
                          setResidentNumberError(
                            "주민등록번호 뒷자리를 정확하게 입력해주세요."
                          );
                        } else {
                          setResidentNumberError("");
                        }
                      } else {
                        setResidentNumberError("");
                      }
                    }

                    // 7자리 입력 완료 시 키보드 닫기
                    if (numericValue.length === 7) {
                      setTimeout(() => {
                        birthDateBackRef.current?.blur();
                      }, 100);
                    }
                  }}
                  onKeyDown={(e) => {
                    // 숫자 키 입력 시 처리
                    if (/^[0-9]$/.test(e.key)) {
                      // 현재 값이 7자리 미만이면 입력 허용
                      if (birthDateBack.length < 7) {
                        const newValue = birthDateBack + e.key;
                        if (newValue.length <= 7) {
                          setBirthDateBack(newValue);

                          // 주민번호 뒷자리 첫 번째 자리 검증 (1, 2, 3, 4로 시작해야 함)
                          if (newValue.length === 1) {
                            if (!["1", "2", "3", "4"].includes(e.key)) {
                              setResidentNumberError(
                                "주민등록번호 뒷자리를 정확하게 입력해주세요."
                              );
                            } else {
                              setResidentNumberError("");
                            }
                          } else if (
                            newValue.length > 1 &&
                            birthDateBack.length === 0
                          ) {
                            // 첫 번째 자리가 이미 입력된 경우 재검증
                            const firstDigit = newValue[0];
                            if (!["1", "2", "3", "4"].includes(firstDigit)) {
                              setResidentNumberError(
                                "주민등록번호 뒷자리는 1, 2, 3, 4로 시작해야 합니다."
                              );
                            } else {
                              setResidentNumberError("");
                            }
                          }

                          e.preventDefault();
                          if (newValue.length === 7) {
                            setTimeout(() => {
                              birthDateBackRef.current?.blur();
                            }, 100);
                          }
                        }
                      } else {
                        e.preventDefault();
                      }
                    }
                    // 백스페이스 키 처리
                    else if (e.key === "Backspace") {
                      if (birthDateBack.length > 0) {
                        const newValue = birthDateBack.slice(0, -1);
                        setBirthDateBack(newValue);
                        // 첫 번째 자리가 삭제되면 에러 메시지도 제거
                        if (newValue.length === 0) {
                          setResidentNumberError("");
                        } else {
                          // 첫 번째 자리 재검증
                          const firstDigit = newValue[0];
                          if (!["1", "2", "3", "4"].includes(firstDigit)) {
                            setResidentNumberError(
                              "주민등록번호 뒷자리를 정확하게 입력해주세요."
                            );
                          } else {
                            setResidentNumberError("");
                          }
                        }
                      }
                    }
                    // Delete 키 처리
                    else if (e.key === "Delete") {
                      if (birthDateBack.length > 0) {
                        const newValue = birthDateBack.slice(0, -1);
                        setBirthDateBack(newValue);
                        // 첫 번째 자리가 삭제되면 에러 메시지도 제거
                        if (newValue.length === 0) {
                          setResidentNumberError("");
                        } else {
                          // 첫 번째 자리 재검증
                          const firstDigit = newValue[0];
                          if (!["1", "2", "3", "4"].includes(firstDigit)) {
                            setResidentNumberError(
                              "주민등록번호 뒷자리를 정확하게 입력해주세요."
                            );
                          } else {
                            setResidentNumberError("");
                          }
                        }
                      }
                    }
                    // 화살표 키, Tab 키는 허용
                    else if (
                      [
                        "ArrowLeft",
                        "ArrowRight",
                        "ArrowUp",
                        "ArrowDown",
                        "Tab",
                      ].includes(e.key)
                    ) {
                      // 허용
                    }
                    // Ctrl/Cmd + A, C, V 등은 허용
                    else if (e.ctrlKey || e.metaKey) {
                      // 허용
                    }
                    // 그 외의 키는 차단
                    else {
                      e.preventDefault();
                    }
                  }}
                  onPaste={(e) => {
                    e.preventDefault();
                    const pastedText = e.clipboardData.getData("text");
                    const numericValue = pastedText
                      .replace(/[^0-9]/g, "")
                      .slice(0, 7);
                    setBirthDateBack(numericValue);

                    // 주민번호 뒷자리 첫 번째 자리 검증 (1, 2, 3, 4로 시작해야 함)
                    if (numericValue.length > 0) {
                      const firstDigit = numericValue[0];
                      if (!["1", "2", "3", "4"].includes(firstDigit)) {
                        setResidentNumberError(
                          "주민등록번호 뒷자리를 정확하게 입력해주세요."
                        );
                      } else {
                        setResidentNumberError("");
                      }
                    } else {
                      setResidentNumberError("");
                    }

                    if (numericValue.length === 7) {
                      setTimeout(() => {
                        birthDateBackRef.current?.blur();
                      }, 100);
                    }
                  }}
                  maxLength={7}
                  ref={birthDateBackRef}
                />
              </ResidentNumberContainer>
              {residentNumberError && (
                <ResidentNumberErrorMessage>
                  {residentNumberError}
                </ResidentNumberErrorMessage>
              )}
            </FormGroup>
            <ResidentInfoBox>
              <ResidentInfoIcon>ⓘ</ResidentInfoIcon>
              <ResidentInfoText>
                해당 정보는 소송 인증에 필요한 정보입니다.
                <br />
                해당 정보는 암호화하여 철저히 관리합니다.
              </ResidentInfoText>
            </ResidentInfoBox>
            </FormGroup>
            */}

            <FormGroup>
              <Label>
                인증수단<Required>*</Required>
              </Label>
              <StyledSelect
                options={authMethodOptions}
                value={authMethod}
                onChange={handleAuthMethodChange}
                placeholder="인증수단을 선택해주세요"
                isSearchable={false}
                classNamePrefix="select"
                menuPortalTarget={document.body}
                isOptionDisabled={(option) => option.isDisabled}
                components={{
                  Option: (props) => (
                    <CustomOption
                      {...props}
                      isDisabled={props.data.isDisabled}
                    />
                  ),
                  SingleValue: CustomSingleValue,
                }}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  menu: (base) => ({
                    ...base,
                    marginTop: "4px",
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                    overflow: "hidden",
                    animation: "slideDown 0.3s ease-out",
                  }),
                  menuList: (base) => ({
                    ...base,
                    padding: "4px 0",
                  }),
                  dropdownIndicator: (base, state) => ({
                    ...base,
                    color: "#999",
                    transition: "transform 0.3s ease",
                    transform: state.selectProps.menuIsOpen
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                  }),
                }}
              />
            </FormGroup>
          </VerificationSection>

          {error && <ErrorMessage>{error}</ErrorMessage>}

          <ButtonsContainer>
            <ActionButton
              onClick={() => setShowAgreementModal(true)}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              disabled={!isNextButtonEnabled || isLoading}
            >
              다음으로
            </ActionButton>
          </ButtonsContainer>
        </Content>
      </Container>

      {/* 이용약관 동의 모달 */}
      <AnimatePresence>
        {showAgreementModal && (
          <AgreementModalOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowAgreementModal(false)}
          >
            <AgreementModalContainer
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
              onClick={(e) => e.stopPropagation()}
            >
              <AgreementModalTitle>서비스 약관</AgreementModalTitle>

              <AgreementModalContent>
                <AgreementItem onClick={() => handleAgreementToggle("terms")}>
                  <AgreementCheckbox>
                    {agreements.terms ? (
                      <CheckedIcon src="/png/checked.png" alt="체크됨" />
                    ) : (
                      <UncheckedIcon
                        src="/png/checkedinActive.png"
                        alt="체크 안됨"
                      />
                    )}
                  </AgreementCheckbox>
                  <AgreementText>
                    <RequiredBadge>[필수]</RequiredBadge> 이용약관에 동의합니다.
                  </AgreementText>
                  <ViewLink
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowTermsModal(true);
                    }}
                  >
                    보기
                  </ViewLink>
                </AgreementItem>

                <AgreementItem onClick={() => handleAgreementToggle("privacy")}>
                  <AgreementCheckbox>
                    {agreements.privacy ? (
                      <CheckedIcon src="/png/checked.png" alt="체크됨" />
                    ) : (
                      <UncheckedIcon
                        src="/png/checkedinActive.png"
                        alt="체크 안됨"
                      />
                    )}
                  </AgreementCheckbox>
                  <AgreementText>
                    <RequiredBadge>[필수]</RequiredBadge> 개인정보 처리방침에
                    동의합니다.
                  </AgreementText>
                  <ViewLink
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowPrivacyModal(true);
                    }}
                  >
                    보기
                  </ViewLink>
                </AgreementItem>

                <AgreementItem
                  onClick={() => handleAgreementToggle("marketing")}
                >
                  <AgreementCheckbox>
                    {agreements.marketing ? (
                      <CheckedIcon src="/png/checked.png" alt="체크됨" />
                    ) : (
                      <UncheckedIcon
                        src="/png/checkedinActive.png"
                        alt="체크 안됨"
                      />
                    )}
                  </AgreementCheckbox>
                  <AgreementText>
                    <OptionalBadge>[선택]</OptionalBadge> 마케팅 수신에
                    동의합니다.
                  </AgreementText>
                  <ViewLink
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowMarketingModal(true);
                    }}
                  >
                    보기
                  </ViewLink>
                </AgreementItem>
              </AgreementModalContent>

              <AgreementModalFooter>
                <AgreementNextButton
                  onClick={handleAgreementNext}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  disabled={!isAgreementNextEnabled}
                >
                  다음으로
                </AgreementNextButton>
              </AgreementModalFooter>
            </AgreementModalContainer>
          </AgreementModalOverlay>
        )}
      </AnimatePresence>

      {/* 이용약관 보기 모달 */}
      <AnimatePresence>
        {showTermsModal && (
          <TermsModalOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowTermsModal(false)}
          >
            <TermsModalContainer
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
              onClick={(e) => e.stopPropagation()}
            >
              <TermsModalHeader>
                <TermsModalTitle>이용약관</TermsModalTitle>
                <CloseButton onClick={() => setShowTermsModal(false)}>
                  ×
                </CloseButton>
              </TermsModalHeader>
              <TermsModalBody>
                <TermsContent />
              </TermsModalBody>
              <TermsModalFooter>
                <TermsConfirmButton
                  onClick={() => {
                    setAgreements((prev) => ({ ...prev, terms: true }));
                    setShowTermsModal(false);
                  }}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  확인
                </TermsConfirmButton>
              </TermsModalFooter>
            </TermsModalContainer>
          </TermsModalOverlay>
        )}
      </AnimatePresence>

      {/* 개인정보 처리방침 보기 모달 */}
      <AnimatePresence>
        {showPrivacyModal && (
          <TermsModalOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowPrivacyModal(false)}
          >
            <TermsModalContainer
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
              onClick={(e) => e.stopPropagation()}
            >
              <TermsModalHeader>
                <TermsModalTitle>개인정보 처리방침</TermsModalTitle>
                <CloseButton onClick={() => setShowPrivacyModal(false)}>
                  ×
                </CloseButton>
              </TermsModalHeader>
              <TermsModalBody>
                <PrivacyContent />
              </TermsModalBody>
              <TermsModalFooter>
                <TermsConfirmButton
                  onClick={() => {
                    setAgreements((prev) => ({ ...prev, privacy: true }));
                    setShowPrivacyModal(false);
                  }}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  확인
                </TermsConfirmButton>
              </TermsModalFooter>
            </TermsModalContainer>
          </TermsModalOverlay>
        )}
      </AnimatePresence>

      {/* 마케팅 수신 동의 보기 모달 */}
      <AnimatePresence>
        {showMarketingModal && (
          <TermsModalOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowMarketingModal(false)}
          >
            <TermsModalContainer
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
              onClick={(e) => e.stopPropagation()}
            >
              <TermsModalHeader>
                <TermsModalTitle>마케팅 수신 동의</TermsModalTitle>
                <CloseButton onClick={() => setShowMarketingModal(false)}>
                  ×
                </CloseButton>
              </TermsModalHeader>
              <TermsModalBody>
                <MarketingContent />
              </TermsModalBody>
              <TermsModalFooter>
                <TermsConfirmButton
                  onClick={() => {
                    setAgreements((prev) => ({ ...prev, marketing: true }));
                    setShowMarketingModal(false);
                  }}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  확인
                </TermsConfirmButton>
              </TermsModalFooter>
            </TermsModalContainer>
          </TermsModalOverlay>
        )}
      </AnimatePresence>

      {/* 이미 신청 완료 안내 모달 */}
      <AnimatePresence>
        {showAlreadyCompletedModal && (
          <CenterModalOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={handleAlreadyCompletedConfirm}
          >
            <CenterModalContainer
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.2 }}
              onClick={(e) => e.stopPropagation()}
            >
              <CenterModalTitle>
                이미 집단소송 신청을 완료하셨습니다.
              </CenterModalTitle>
              <CenterModalBody>
                <CenterModalText>
                  소송 진행 상황은 메인 페이지에서 확인하실 수 있습니다.
                </CenterModalText>
              </CenterModalBody>
              <CenterModalFooter>
                <CenterModalButton
                  onClick={handleAlreadyCompletedConfirm}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  확인
                </CenterModalButton>
              </CenterModalFooter>
            </CenterModalContainer>
          </CenterModalOverlay>
        )}
      </AnimatePresence>

      {/* 인증수단 없음 안내 모달 */}
      <AnimatePresence>
        {showNoAuthMethodModal && (
          <CenterModalOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={handleNoAuthMethodCancel}
          >
            <CenterModalContainer
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
              onClick={(e) => e.stopPropagation()}
            >
              <CenterModalTitle>
                소셜 본인인증이 불가능 하신가요?
              </CenterModalTitle>
              <CenterModalBody>
                <CenterModalText>
                  직접 이름과 전화번호를 입력해 주세요.
                  <br /> 입력 정보가 정확하지 않으면 인증이 진행되지
                  <br /> 않을 수 있습니다.
                  <br />
                  <BoldText>정확한 이름과 전화번호</BoldText>를 기재해 주세요.
                </CenterModalText>
              </CenterModalBody>
              <CenterModalFooter>
                <CenterModalButton
                  $isCancel
                  onClick={handleNoAuthMethodCancel}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  아니오
                </CenterModalButton>
                <CenterModalButton
                  onClick={handleNoAuthMethodConfirm}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  예
                </CenterModalButton>
              </CenterModalFooter>
            </CenterModalContainer>
          </CenterModalOverlay>
        )}
      </AnimatePresence>

      {/* 정보 불일치 모달 */}
      <AnimatePresence>
        {showMismatchModal && (
          <CenterModalOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowMismatchModal(false)}
          >
            <CenterModalContainer
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
              onClick={(e) => e.stopPropagation()}
            >
              <CenterModalTitle>인증 실패</CenterModalTitle>
              <CenterModalBody>
                <CenterModalText>
                  {authMethod?.label || "선택된 인증수단"}에 등록된 정보와
                  일치하지 않습니다.
                </CenterModalText>
              </CenterModalBody>
              <CenterModalFooter>
                <CenterModalButton
                  onClick={() => setShowMismatchModal(false)}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  style={{ width: "100%" }}
                >
                  확인
                </CenterModalButton>
              </CenterModalFooter>
            </CenterModalContainer>
          </CenterModalOverlay>
        )}
      </AnimatePresence>

      {/* 외국인/미성년자 접수 불가 알림 */}
      <AnimatePresence>
        {showToast2 && (
          <Toast2
            variants={toast2Variants}
            initial="initial"
            animate="animate"
            exit="exit"
          >
            <AlertIcon>!</AlertIcon>
            {toastMessage2}
          </Toast2>
        )}
      </AnimatePresence>
    </PageBackground>
  );
};

// 스타일 컴포넌트
const PageBackground = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 0;
  background-color: #f6f8ff;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  @media (min-width: 769px) {
    padding: 40px 20px 60px;
    background-color: #f6f8ff;
  }
`;

const Container = styled(motion.div)`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: #f6f8ff;

  /* 모바일 디바이스 */
  @media (max-width: 768px) {
    min-height: auto;
    box-shadow: none;
    padding: 0 0 80px 0;
    max-width: 100%;
    margin: 0;
    border-radius: 0;
  }

  /* 데스크탑 디바이스 */
  @media (min-width: 769px) {
    border-radius: 20px;
    min-height: auto;
    max-height: none;
    max-width: 470px;
    margin: 0 auto;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    padding: 20px;
  }
`;

const Content = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  width: 100%;
  position: relative;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 60px 20px 80px;
  }

  @media (min-width: 769px) {
    padding: 40px 30px 40px 30px;
  }
`;

const Header = styled.div`
  width: 100%;
  margin-bottom: 20px;
  color: #333;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const SubTitle = styled.h2`
  font-size: 28px;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 10px;
  word-break: keep-all;
  color: #333;
  text-align: left;
  width: 100%;
`;

const Description = styled.p`
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
  line-height: 1.4;
`;

const InfoBox = styled.div`
  width: 100%;
  background-color: white;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  box-sizing: border-box;
`;

const ResidentInfoBox = styled.div`
  width: 100%;
  background-color: white;
  border-radius: 12px;
  padding: 0px 16px 0 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-sizing: border-box;

  /* VerificationSection 내부에 있을 때 패딩 상쇄 */
  margin-left: -24px;
  margin-right: -24px;
  width: calc(100% + 48px);
`;

const InfoIcon = styled.span`
  color: #0075ff;
  margin-top: 0px;
  font-size: 16px;
  margin-right: 0px;
  font-weight: bold;
  flex-shrink: 0;
`;

const InfoText = styled.p`
  font-size: 13px;
  color: #333;
  line-height: 1.5;
  margin: 0;
  flex: 1;
`;

const ResidentInfoIcon = styled.span`
  color: #0075ff;
  margin-top: 0px;
  font-size: 16px;
  margin-right: 0px;
  font-weight: bold;
  flex-shrink: 0;
`;

const ResidentInfoText = styled.p`
  font-size: 13px;
  color: #333;
  line-height: 1.5;
  margin: 0;
  flex: 1;
`;

const VerificationSection = styled.div`
  width: 100%;
  background-color: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  box-sizing: border-box;
`;

const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin: 0 0 8px 0;
`;

const FormGroup = styled.div`
  width: 100%;
  margin-bottom: 0px;
`;

const Label = styled.label`
  display: block;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #2e3840;
`;

const Required = styled.span`
  color: #fe7156;
  margin-left: 2px;
`;

const Input = styled.input`
  flex: 1;
  height: 56px;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  padding: 0 16px;
  font-size: 16px;
  background-color: white;
  width: 100%;
  box-sizing: border-box;
  letter-spacing: ${(props) => (props.isNumeric ? "2px" : "normal")};

  &::placeholder {
    color: #999;
    letter-spacing: normal;
  }

  &:focus {
    border-color: #0075ff;
    outline: none;
  }
`;

const ResidentNumberContainer = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
`;

const ResidentNumberInput = styled.input`
  width: calc(50% - 4px);
  height: 56px;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  padding: 0 16px;
  font-size: 16px;
  background-color: white;
  box-sizing: border-box;
  letter-spacing: 6px;
  text-align: center;

  &:first-child {
    margin-right: 8px;
  }

  &::placeholder {
    color: #999;
    letter-spacing: normal;
  }

  &:focus {
    outline: none;
    border-color: #3855e2;
  }
`;

const ButtonsContainer = styled.div`
  max-width: 400px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-top: 0px;
  padding: 0 0px;
  background-color: #f6f8ff;
  margin: 0 auto;

  @media (min-width: 769px) {
    padding: 0;
    background-color: transparent;
    justify-content: center;
  }
`;

const ActionButton = styled(motion.button)`
  flex: 1;
  display: flex;
  height: 56px;
  padding: 0px 14px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 20px;
  background: ${(props) => (props.disabled ? "#A9DAFF" : "#3855E2")};
  color: ${(props) => (props.disabled ? "#CCEAFF" : "white")};
  font-size: 16px;
  font-weight: 600;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  border: none;
  opacity: ${(props) => (props.disabled ? 1 : 1)};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
`;

const ErrorMessage = styled.div`
  width: 100%;
  padding: 12px 16px;
  margin-bottom: 20px;
  background-color: #fff5f5;
  border: 1px solid #ffcccc;
  border-radius: 8px;
  color: #d32f2f;
  font-size: 14px;
  text-align: center;
`;

const ResidentNumberErrorMessage = styled.div`
  width: 100%;
  padding: 12px 16px;
  margin-top: 8px;
  background-color: #fff5f5;
  border: 1px solid #ffcccc;
  border-radius: 8px;
  color: #d32f2f;
  font-size: 14px;
  text-align: left;
`;

const PollingOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

const PollingModal = styled(motion.div)`
  background-color: white;
  border-radius: 16px;
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #e3f2fd;
  border-top-color: #1976d2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  flex-shrink: 0;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const PollingIndicatorText = styled.div`
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  text-align: center;
`;

// 이용약관 동의 모달 스타일
const AgreementModalOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 1000;
  touch-action: none;

  @media (min-width: 769px) {
    align-items: center;
  }
`;

const AgreementModalContainer = styled(motion.div)`
  width: 100%;
  max-width: 500px;
  background-color: white;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 80vh;

  @media (min-width: 769px) {
    border-radius: 16px;
    max-width: 420px;
    max-height: 90vh;
  }
`;

const AgreementModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  padding: 20px;
  margin: 0;
  text-align: center;
  border-bottom: 1px solid #eee;
`;

const AgreementModalContent = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 0;
  flex: 1;
  overflow-y: auto;
`;

const AgreementItem = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 0;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
`;

const AgreementCheckbox = styled.div`
  width: 24px;
  height: 24px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const CheckedIcon = styled.img`
  width: 24px;
  height: 24px;
`;

const UncheckedIcon = styled.img`
  width: 24px;
  height: 24px;
`;

const AgreementText = styled.div`
  flex: 1;
  font-size: 15px;
  font-weight: 600;
  color: #131313;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const RequiredBadge = styled.span`
  color: #fe7156;
  font-weight: 600;
`;

const OptionalBadge = styled.span`
  color: #999;
  font-weight: 600;
`;

const ViewLink = styled.button`
  background: none;
  border: none;
  color: #0075ff;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  margin-left: 8px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const AgreementModalFooter = styled.div`
  padding: 20px;
  border-top: 1px solid #eee;
`;

const AgreementNextButton = styled(motion.button)`
  width: 100%;
  height: 56px;
  border-radius: 12px;
  background: ${(props) => (props.disabled ? "#A9DAFF" : "#3855E2")};
  color: ${(props) => (props.disabled ? "#CCEAFF" : "white")};
  font-size: 16px;
  font-weight: 600;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  border: none;
  opacity: 1;
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
`;

// 전역 스타일로 react-select 메뉴 애니메이션 추가
const GlobalSelectStyles = createGlobalStyle`
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

// 인증수단 선택 스타일
const StyledSelect = styled(Select)`
  .select__control {
    height: 56px;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: none;
    background: white;

    &:hover {
      border-color: #0075ff;
    }

    &--is-focused {
      border-color: #0075ff;
      box-shadow: 0 0 0 1px #0075ff;
    }
  }

  .select__placeholder {
    color: #999;
  }

  .select__single-value {
    color: #333;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .select__input {
    color: #333 !important;

    input {
      color: #333 !important;
    }
  }

  .select__input-container {
    margin: 0;
    padding: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    color: #333;

    input {
      opacity: 0 !important;
      width: 0 !important;
      height: 0 !important;
      padding: 0 !important;
      border: none !important;
      position: absolute;
      color: #333 !important;

      &:focus {
        opacity: 1 !important;
        width: 100% !important;
        height: auto !important;
        position: relative;
      }
    }
  }

  .select__value-container {
    padding: 2px 16px;
    cursor: pointer;
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
  }

  .select__indicator-separator {
    display: none;
  }

  .select__dropdown-indicator {
    color: #999;
  }
`;

const OptionContainer = styled.div`
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: ${(props) => (props.$isDisabled ? "not-allowed" : "pointer")};
  min-height: 40px;
  opacity: ${(props) => (props.$isDisabled ? 0.5 : 1)};

  &:hover {
    background-color: ${(props) =>
      props.$isDisabled ? "transparent" : "#f5f5f5"};
  }
`;

const SingleValueContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 100%;
  position: relative;
  top: 0;
`;

const AuthIcon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
  flex-shrink: 0;
  opacity: ${(props) => (props.$isDisabled ? 0.5 : 1)};
`;

const OptionTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
`;

const OptionLabel = styled.span`
  font-size: 16px;
  color: ${(props) => (props.$isDisabled ? "#999" : "#333")};
`;

const PreparingText = styled.span`
  font-size: 12px;
  color: #999;
  line-height: 1.2;
`;

// 이용약관/개인정보 처리방침 모달 스타일
const TermsModalOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 1001;
  touch-action: none;

  @media (min-width: 769px) {
    align-items: center;
  }
`;

const TermsModalContainer = styled(motion.div)`
  width: 100%;
  max-width: 500px;
  background-color: white;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 80vh;

  @media (min-width: 769px) {
    border-radius: 16px;
    max-width: 600px;
    max-height: 90vh;
  }
`;

const TermsModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;
`;

const TermsModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
  flex: 1;
  text-align: center;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 28px;
  color: #999;
  padding: 0;
  margin: 0;
  cursor: pointer;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
`;

const TermsModalBody = styled.div`
  padding: 20px;
  overflow-y: auto;
  flex: 1;
  font-size: 14px;
  line-height: 1.8;
`;

// 이용약관 스타일 컴포넌트
const TermsContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: #333;
  font-size: 14px;
  line-height: 1.8;
`;

const TermsIntro = styled.p`
  margin-bottom: 20px;
  line-height: 1.8;
`;

const TermsChapter = styled.div`
  margin-bottom: 24px;
`;

const TermsChapterTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #00285b;
`;

const TermsSection = styled.div`
  margin-bottom: 20px;
`;

const TermsSectionTitle = styled.h4`
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
`;

const TermsText = styled.p`
  margin-bottom: 8px;
  line-height: 1.8;
`;

const TermsList = styled.ul`
  list-style: disc;
  margin-left: 20px;
  margin-bottom: 12px;
  padding-left: 0;

  li {
    margin-bottom: 6px;
    line-height: 1.8;
  }
`;

const TermsFooter = styled.p`
  margin-top: 20px;
  font-size: 13px;
  color: #666;
  line-height: 1.8;
`;

// 마케팅 수신 동의 스타일 컴포넌트
const MarketingContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: #333;
  font-size: 14px;
  line-height: 1.8;
`;

const MarketingIntro = styled.p`
  margin-bottom: 20px;
  line-height: 1.8;
`;

const MarketingSection = styled.div`
  margin-bottom: 20px;
`;

const MarketingSectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
`;

const MarketingText = styled.p`
  margin-bottom: 8px;
  line-height: 1.8;
`;

// 개인정보 처리방침 스타일 컴포넌트
const PrivacyContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: #333;
  font-size: 14px;
  line-height: 1.8;
`;

const PrivacyIntro = styled.p`
  margin-bottom: 20px;
  line-height: 1.8;
`;

const PrivacySection = styled.div`
  margin-bottom: 20px;
`;

const PrivacySectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
`;

const PrivacyText = styled.p`
  margin-bottom: 8px;
  line-height: 1.8;
`;

const PrivacyList = styled.ul`
  list-style: disc;
  margin-left: 20px;
  margin-bottom: 12px;
  padding-left: 0;

  li {
    margin-bottom: 6px;
    line-height: 1.8;
  }
`;

const PrivacyTableWrapper = styled.div`
  overflow-x: auto;
  margin: 15px 0;
`;

const PrivacyTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;
  font-size: 13px;
  min-width: 600px;

  thead {
    background-color: #f5f5f5;
  }

  th {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
    font-weight: 600;
    background-color: #f5f5f5;
  }

  td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }

  tr {
    &:nth-child(even) {
      background-color: #fafafa;
    }
  }
`;

const PrivacyContactInfo = styled.div`
  margin: 12px 0;
  padding: 12px;
  background-color: #f9f9f9;
  border-radius: 4px;
  line-height: 1.8;

  strong {
    font-weight: 600;
    display: block;
    margin-bottom: 8px;
  }
`;

const PrivacyFooter = styled.p`
  margin-top: 20px;
  font-size: 13px;
  color: #666;
  line-height: 1.8;
`;

const TermsModalFooter = styled.div`
  padding: 15px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: center;
  position: sticky;
  bottom: 0;
  background: white;
`;

const TermsConfirmButton = styled(motion.button)`
  width: 100%;
  height: 56px;
  border-radius: 12px;
  background: #3855e2;
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border: none;
`;

// 중앙 모달 스타일
const CenterModalOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
  padding: 20px;
`;

const CenterModalContainer = styled(motion.div)`
  width: 100%;
  max-width: 400px;
  background-color: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`;

const CenterModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  padding: 24px 24px 16px;
  margin: 0;
  text-align: left;
`;

const CenterModalBody = styled.div`
  padding: 0 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const CenterModalText = styled.p`
  font-size: 14px;
  color: #000;
  line-height: 1.3;
  margin: 0;
  text-align: left;
`;

const BoldText = styled.span`
  font-weight: 700;
`;

const CenterModalFooter = styled.div`
  padding: 0 24px 24px;
  display: flex;
  gap: 8px;
`;

const CenterModalButton = styled(motion.button)`
  flex: 1;
  height: 48px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border: ${(props) => (props.$isCancel ? "1px solid #e5e5e5" : "none")};
  background: ${(props) => (props.$isCancel ? "white" : "#3855E2")};
  color: ${(props) => (props.$isCancel ? "#333" : "white")};
`;

// 토스트 애니메이션 variants
const toast2Variants = {
  initial: {
    opacity: 0,
    y: -80,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
    },
  },
  exit: {
    opacity: 0,
    y: -80,
    transition: {
      duration: 0.3,
    },
  },
};

const Toast2 = styled(motion.div)`
  position: fixed;
  top: 230px;
  left: 5%;
  /* 데스크탑에서는 32%로 위치 조정 */
  @media (min-width: 768px) {
    left: 40%;
  }

  transform: translateX(-50%);
  background-color: rgba(46, 56, 64, 0.9);
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-size: 14px;
  z-index: 1000;
  min-width: 90%;
  max-width: 90%;
  text-align: left;

  @media (min-width: 768px) {
    min-width: auto;
    max-width: 400px;
    width: auto;
  }
`;

const AlertIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background-color: #0075ff;
  color: white;
  border-radius: 50%;
  margin-right: 8px;
  font-size: 16px;
  font-weight: bold;
`;

export default IdentityVerificationInputPage;
